import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import {SettingsProvider} from "./SettingsContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
// console.log("Environment Variables:", process.env);

root.render(
  
  <React.StrictMode>
      <SettingsProvider>
          <App />
      </SettingsProvider>
  </React.StrictMode>
);

reportWebVitals();
